module.exports = __webpack_public_path__ + "static/website-ecbdcff00cec7de24ad12279783ae157.svg";